import React from 'react';
import { CSSTransition } from 'react-transition-group';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import fastAppearAnimationClasses from '../../../../../../../../animations/fast-appear.anim.scss';
export default function ProductDetailsNumber({
  number
}) {
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: fastAppearAnimationClasses,
    key: number,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.number
  }, number));
}